exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".msg.warning {\n  display: flex;\n  align-items: center;\n  font-weight: 400; }\n  .msg.warning svg {\n    margin-right: 10px;\n    color: #e9b949; }\n", ""]);

// exports
